module.exports = __webpack_public_path__ + "img/icon-scan-failed.5fa2701c.svg";